<style>
  .notLogin {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    & > .header-wrapper{
      width: 1200px;
      margin: auto;
    }
  }
  .nav .domain-select {
    padding: 0;
  }
</style>
<template lang="pug">
div
  PrivacyModal(v-if="isPrivacyShown === '0' && userName")
  NavBar
    UnionLoginFailed(v-if="unionLoginFailed")
    router-view(v-else-if="userName != ''")
    IndexPage(v-else-if="userName == ''")
  CodeTipModal(
    v-if="isntFenxiUser"
    :type="usrType"
    :time="time"
    :defaulttime="defaulttime"
    )
  
</template>

<script>
/* global _ */
import Vue from 'vue'
import Footer from './component/footer.vue'
import IndexPage from './index.vue'
import NavBar from './component/navbar.vue'
import CodeTipModal from './component/codetipModal.vue'
import PrivacyModal from './component/privacyModal.vue'
import UnionLoginFailed from './pageview/unionLoginFailed.vue'
Vue.component('site-footer', Footer)

export default {
  components: {
    NavBar,
    IndexPage,
    CodeTipModal,
    PrivacyModal,
    UnionLoginFailed
  },
  data () {
    return {
      isntFenxiUser: false,
      userName: window.$userName || '',
      unionLoginFailed: false,
      usrType: 1,
      time: '',
      defaulttime: '2018-07-10',
      isPrivacyShown: window.$userPrivacyStatus || '0'
    }
  },
  computed: {
    domainList () {
      return this.$store.state.domainList || []
    },
    domainId () {
      return this.$store.state.domainId
    }
  },
  methods: {
    checkDianjingUserBind () {
      const djBindParams = window.$djBindParams
      let isAllFilled = true
      if (!djBindParams) {
        return
      }

      _.map(_.keys(djBindParams), (key) => {
        if (!djBindParams[key]) {
          isAllFilled = false
        }
        djBindParams[key] = decodeURIComponent(djBindParams[key])
      })

      if (!isAllFilled) {
        return
      }

      const { key, user, domain, platform, djUser } = djBindParams
      const platformInfo = {
        dianjing: {
          message: `是否同意网站 ${domain} 的管理员【 ${user} 】绑定您的点睛账户【 ${djUser} 】`,
          confirmUrl: `/api/adv_system/affirm?do=1&key=${key}`,
          rejectUrl: `/api/adv_system/affirm?do=2&key=${key}`
        },
        bool: {
          message: `是否同意360分析用户【 ${user} 】绑定您的点睛-应用推广账号【 ${djUser}】`,
          confirmUrl: `/api/booladsystem/affirm?do=1&key=${key}`,
          rejectUrl: `/api/booladsystem/affirm?do=2&key=${key}`
        }
      }

      const { message, confirmUrl, rejectUrl } = platformInfo[platform]
      this.$Modal.confirm(message, res => {
        if (res) {
          this.$http.get(confirmUrl).then(e => {
            const data = e.data
            if (data.errno > 0) {
              this.$Modal.warn(data.errmsg)
            } else {
              this.$Modal.alert('綁定成功')
              this.$router.replace(this.$route.path)
            }
          }).catch(e => {
            this.$Modal.warn('网络错误')
          })
        } else {
          this.$http.get(rejectUrl)
        }
      })
    },
    checkUserType () {
      // 超过预设时间只展现一次
      let outTimeVisited = false
      let users = {}
      try {
        users = JSON.parse(localStorage.__fx_domaintype_users)
      } catch (e) {
        users = {}
      }
      Object.keys(users).map(key => {
        if (new Date(key).getTime() >= new Date(this.defaulttime).getTime()) {
          outTimeVisited = true
        }
      })
      if (outTimeVisited) return
      this.$http.get('/api/usertype/type', {params: {domainId: this.domainId}})
        .then(({data}) => {
          if (data.errno > 0) {
            this.$Modal.warn(data.errmsg)
            return
          }
          this.usrType = +data.type
          this.time = data.date
          // 2018-07-10 change message tip
          const isOutTime = new Date(this.time).getTime() >= new Date(this.defaulttime).getTime()
          if (this.usrType === 1) return
          if (this.usrType === 2 && isOutTime) return
          // 每天弹窗一次
          const usrFlag = `${this.userName}`
          const hasTime = _.has(users, this.time)
          if (hasTime) {
            const hasUsrVisited = users[this.time].includes(usrFlag)
            this.isntFenxiUser = !hasUsrVisited
            !hasUsrVisited && users[this.time].push(usrFlag)
          } else {
            users[this.time] = []
            users[this.time].push(usrFlag)
            this.isntFenxiUser = true
          }
          // 清除过往信息
          const todayUsers = {}
          todayUsers[this.time] = users[this.time]
          localStorage.__fx_domaintype_users = JSON.stringify(todayUsers)
        }).catch(e => {
          this.$Modal.warn('网络错误')
        })
    },
    hasRememberUsrType () {
      /* eslint-disable no-mixed-operators */
      return !_.has(localStorage, '__fx_notypetip_usrs') ||
        _.has(localStorage, '__fx_notypetip_usrs') &&
        !localStorage.__fx_notypetip_usrs.includes(this.userName)
    }
  },
  created () {
    // 如果没有任何域名信息 则跳转
    this.unionLoginFailed = this.$route.path === '/unionLoginFailed'
    !this.domainList.length && Boolean(window.$hasPermission) && this.$router.replace('/setting/sites')
    Boolean(this.userName) && this.$route.path === '/' && this.$router.replace('/web/overview')
    Boolean(this.userName) && this.hasRememberUsrType() && this.checkUserType()
  },
  mounted () {
    this.checkDianjingUserBind()
  }
}
</script>

<style scoped>
#login_info {
    float: right;
    font-size: 12px;
    margin-top: 8px;
}
@media screen and (max-width: 1000px) {
    #login_info > .nav-right {
        display: none;
    }
}
.nav-right {
    > a,
    > span {
        display: inline-block;
        margin-right: 15px;
        color: #fff;
        padding: 0 1em;
        &:hover {
          border-bottom: 2px solid #fff;
        }
      }
    > a.logout {
      margin-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// main.vue?1b1b1ef6